<template>
    <edit-base-template 
            v-on:update='updateItem()'
            v-on:create='createItem()'
            v-on:cancel='cancelEdit()'
            v-on:delete='deleteItem()'
            :item='item' 
            :errors='errors' 
            :title='formTitle()'
            :candelete='true'>
        
        <template v-slot:body>
            <div class="form-group">
                <label for='name'>{{ $t('translations.name') }} <span class="required-field">*</span></label>
                <input type='text' v-model='item.name' class='form-control'>
            </div>

            <div class="form-group">
                <label for='name'>{{ $t('translations.start_date') }}</label>
                <datetime2 v-model="item.start_at"></datetime2>
            </div>

            <div class="form-group">
                <label for='name'>{{ $t('translations.end_date') }}</label>
                <datetime2 v-model="item.end_at"></datetime2>
            </div>

            <div class="form-group">
                <label for='name'>{{ $t('translations.cohorts') | capitalise }} <span class="required-field">*</span></label>
                <select  size="10" multiple='true' v-model='item.cohort_id' class='form-control' >
                    <!-- <option :value='null'>{{ $t('translations.global')}}</option> -->
                    <option v-for="(cohort) in cohorts" :value="cohort.id" :key="cohort.id">{{cohort.name}}</option>
                </select>
            </div>
            <div class="form-group">
                <label for='name'>{{ $t('translations.custom_action') | capitalise }} <span class="required-field">*</span></label>
                <select v-model='item.custom_action_id' class='form-control' >
                    <!-- <option disabled value="">Please select one</option> -->
                    <option v-for="(custom_action) in custom_actions" :value="custom_action.id" :key="custom_action.id">{{custom_action.title}}</option>
                </select>
            </div>
            <hr >
            <div class="form-group">
                <label for='invite_title'>{{ $t('translations.invite_title') | capitalise }} <span class="required-field">*</span></label>
                <input type='text' v-model='item.invite_title' class='form-control'>
            </div>
            <div class="form-group">
                <label>{{ $t('translations.invite_message') | capitalise }} <span class="required-field">*</span></label>
                <textarea class="new-message new-message-practice p-1" v-model="item.invite_message" 
                id="invite_message_textarea" type="textarea"></textarea>
                
                <!-- <textarea v-on:keyup.enter.exact="processMessage"  :class='"new-message p-1" + (internal_message ? " list-message-internal" : "")' v-model="new_message" type="textarea"  v-text='new_message'></textarea> -->
                <p class='chars-left' aria-live="polite">{{inviteMessageCharactersLeft}}</p>
                <preset-message-select 
                    targetId='invite_message_textarea' 
                    @select='item.invite_message = $event.text'>
                    </preset-message-select>
            </div>
            <div class="form-group">
                <label for='invite_call_to_action'>{{ $t('translations.invite_call_to_action') | capitalise }} <span class="required-field">*</span></label>
                <input type='text' maxlength='191' v-model='item.invite_call_to_action' class='form-control'>
            </div>
            <button class='btn btn-primary btn-round' v-on:click='sendTestEmail(1)'>Send invite to yourself</button>
            <hr >

            <div class="form-group">
                <label for='reminder_title'>{{ $t('translations.reminder_title') | capitalise }}</label>
                <input type='text' maxlength='191' v-model='item.reminder_title' class='form-control'>
            </div>
            <div class="form-group">
                <label>{{ $t('translations.reminder_message') | capitalise }}</label>
                <textarea class="new-message new-message-practice p-1" v-model="item.reminder_message" 
                id="reminder_message_textarea" type="textarea"></textarea>
                
                <!-- <textarea v-on:keyup.enter.exact="processMessage"  :class='"new-message p-1" + (internal_message ? " list-message-internal" : "")' v-model="new_message" type="textarea"  v-text='new_message'></textarea> -->
                <p class='chars-left' aria-live="polite">{{reminderMessageCharactersLeft}}</p>
                <preset-message-select 
                    targetId='reminder_message_textarea' 
                    @select='item.reminder_message = $event.text'>
                    </preset-message-select>
            </div>
            <div class="form-group">
                <label for='reminder_call_to_action'>{{ $t('translations.reminder_call_to_action') | capitalise }}</label>
                <input type='text' maxlength='191' v-model='item.reminder_call_to_action' class='form-control'>
            </div>
            <button class='btn btn-primary btn-round' v-on:click='sendTestEmail(2)'>Send reminder to yourself</button>
            
        </template>

    </edit-base-template>
</template>

<script>
import DateTime from '../DateTime.vue';
	export default {
  components: { DateTime },
        extends: app.base.editBase,
		props: [
		],
		data: function(){
			return {
                title: 'Campaign',
                event: "campaign",
                model: "campaign",
                elementname: "Campaign",
                route: '/api/v1/campaigns',
                forms: [],
                auto_tag: null,
                ug_assign: null,
                item: {
                    name: "",
                    cohort_id: [],
                    start_at: null,
                    end_at: null,
                    custom_action_id: null,
                    invite_title: "",
                    invite_message: "",
                    invite_call_to_action: "",
                    reminder_title: "",
                    reminder_message: "",
                    reminder_call_to_action: "",
                },
                cohorts: [],
                custom_actions: [],
                test_email: this.$root.user.email,
			};
		},
        
        computed: {
            icons() {
                return this.arrayToAutocomplete(this.$root.fontawesome);
            },
            authHeaders () {
                return {
                    'Authorization': axios.defaults.headers.common['Authorization'],
                    'X-Api-Version': axios.defaults.headers.common['X-Api-Version']
                }
            },
            inviteMessageCharactersLeft() {
				var char = this.item.invite_message ? this.item.invite_message.length : 0;
				var limit = 2048;

				if(char > limit) {
					this.item.invite_message = this.item.invite_message.substr(0, limit);
					char = this.item.invite_message.length;
				}
				return (limit - char) + " " + this.$t('translations.characters_remaining');
			},
            reminderMessageCharactersLeft() {
				var char = this.item.reminder_message ? this.item.reminder_message.length : 0;
				var limit = 2048;

				if(char > limit) {
					this.item.reminder_message = this.item.reminder_message.substr(0, limit);
					char = this.item.reminder_message.length;
				}
				return (limit - char) + " " + this.$t('translations.characters_remaining');
			},
        },
        watch: {
            
        },
        mounted() {
            axios.all([axios.get('/api/v1/cohorts?p=0', {}), axios.get('/api/v1/custom_actions?p=0', {})])
                .then(axios.spread((cohorts, custom_actions) => {
                    this.cohorts = this.sortByValue(cohorts.data.data);
                    this.custom_actions = this.sortByValue(custom_actions.data.data, "title");
                    this.setLoading(false);
                }))
                .catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "load");
                    this.$router.push({path: "/" + this.event + "-list"});
                });
        },
        methods: {
            getName() {
                return this.item.name;
            },
            resetItem() {
                this.item = {
                    name: "",
                    cohort_id: [],
                    start_at: null,
                    end_at: null,
                    custom_action_id: null,
                    invite_title: "",
                    invite_message: "",
                    invite_call_to_action: "",
                    reminder_title: "",
                    reminder_message: "",
                    reminder_call_to_action: "",
                };

                this.errors = [];
                this.originalData = JSON.parse(JSON.stringify(this.item));
            },
            loadItem(id) {
                this.setLoading(true);
                axios.get(this.route + '/' + id )
                    .then((campaign => {
                        this.item = campaign.data[this.model];
                        this.item.cohort_id = [];
                        this.item.campaign_cohort_xref.forEach(obj => {
                            this.item.cohort_id.push(obj.cohort_id);
                        })
                        this.originalData = JSON.parse(JSON.stringify(this.item));
                        this.setLoading(false);
                    }))
                    .catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "load");
                        this.$router.push({path: "/" + this.event + "-list"});
                    });
            },
            sendTestEmail(type) {
                this.setLoading(true);
                axios.post(`/api/v1/campaigns/testEmail/${type}`, this.item).then(res => {
                    this.setLoading(false);
                    this.addNotification({type: "success", content: this.$t('translations.test_email_sent_to', {"email": this.$root.user.email})});
                })
                .catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "send reminder");
                });
            }
        }

    }
</script>
